export default __webpack_public_path__ + "static/1-36-0-timezone-67f42d13209a6c44dae4f9c5aea5e4f3.png";